module.exports = __webpack_public_path__ + "static/img/kjy.148657b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/kjy.jpg
// module id = CYF2
// module chunks = 0